import type {
  MarketplaceNearbyZonesInput,
  MarketplaceViewportAreaNameQuery,
} from './__generated__/viewport-area-name.zeus';
import type { GeoPoint } from './types';

const SEARCH_DISTANCE_METERS = 160_000;

export const getViewportCenter = (vertices: GeoPoint[]): GeoPoint | null => {
  if (vertices.length === 0) {
    return null;
  }

  const latitudes = vertices.map(({ lat }) => lat);
  const longitudes = vertices.map(({ lon }) => lon);
  return {
    lat: (Math.min(...latitudes) + Math.max(...latitudes)) / 2,
    lon: (Math.min(...longitudes) + Math.max(...longitudes)) / 2,
  };
};

export const getViewportAreaNameInput = ({ lat, lon }: GeoPoint): MarketplaceNearbyZonesInput => ({
  latitude: lat,
  limit: 1,
  longitude: lon,
  searchDistanceMeters: SEARCH_DISTANCE_METERS,
  types: ['CITY'],
});

export const getViewportAreaName = (data: MarketplaceViewportAreaNameQuery): string | null => {
  const zone = data.marketplace.nearbyZones[0];
  return zone ? [zone.name, zone.stateAbbr].filter(Boolean).join(', ') : null;
};
